export const TRON_LINK_NAME = 'TronLink';
export const TRUST_WALLET_NAME = 'TrustWallet';